export const APP_STORE_URL = 'https://apps.apple.com/ca/app/monprof-mutrix/id6753905724';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=mutrix.app.concours';
